import { ReactNode } from "react";

import { TextField } from "@mui/material";

const FieldHeight = 40;

interface Props {
  label: string;
  value: string;
  rows?: number;
  link?: ReactNode;
}

export function EdictDetailField({ label, value, rows, link }: Props) {
  return (
    <TextField
      fullWidth
      size="small"
      label={label}
      value={link ? "" : value}
      multiline={rows !== undefined}
      rows={rows}
      sx={
        link
          ? {
              "& .MuiInputBase-input": { width: 0, minWidth: 0, padding: 0, flexGrow: 1 },
              "& .MuiInputBase-root": { minHeight: FieldHeight },
            }
          : undefined
      }
      slotProps={{ inputLabel: { shrink: true }, input: { readOnly: true, startAdornment: link } }}
    />
  );
}
